import { render, staticRenderFns } from "./CompAdminMenu.vue?vue&type=template&id=75b21af8&"
import script from "./CompAdminMenu.vue?vue&type=script&lang=js&"
export * from "./CompAdminMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports